module.exports = __webpack_public_path__ + "img/11.e6d885e3.jpg";